import * as types from './types';
import * as commonTypes from '../common/types';

export default (state = {}, action) => {
    switch (action.type) {
        case commonTypes.ASYNC_START: {
            return {
                ...state,
                loading: true,
                waitting: action.waitting,
                action: commonTypes.ASYNC_START,
            }
        }

        case commonTypes.ASYNC_END: {
            return {
                ...state,
                action: commonTypes.ASYNC_END,
                waitting: commonTypes.ASYNC_END,
                loading: false,
            }
        }
        case types.ADMIN_LIST: {
            return {
                ...state,
                action: types.ADMIN_LIST,
                admins: action.status ? action.payload.admins : [],
                totalRecord: action.status ? action.payload.total : 0,
                totalPage: action.status ? action.payload.total_page : 0,
                status: action.status,
                message: action.message,
            }
        }
        case types.CREATE_ADMIN: {
            return {
                ...state,
                action: types.CREATE_ADMIN, 
                status: action.status,
                message: action.message,
            }
        } 
        case types.ADMIN_UPDATE_ADMIN: {
            return {
                ...state,
                action: types.ADMIN_UPDATE_ADMIN, 
                status: action.status,
                message: action.message,
            }
        } 
        case types.GET_ROLE_LIST: {
            return {
                ...state,
                action: types.GET_ROLE_LIST,
                roles: action.status ? action.payload.roles : [],
                status: action.status,
                message: action.message,
            }
        }
        default:
            return state;
    }
}

